<div class="ft-dp">
  <eds-label class="ft-dp-label" for="label" [label]="label"></eds-label>
  <dp-date-picker
    [mode]="type"
    [config]="config"
    [placeholder]="placeholder"
    [displayDate]="displayDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    (onSelect)="dateSelected($event)"
    theme="ft-material"
    [(ngModel)]="selectedDate"
    (open)="onCalendarDraw()"
    (onLeftNav)="onCalendarDraw()"
    (onRightNav)="onCalendarDraw()"
  >
  </dp-date-picker>
</div>
